import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

const _get = async (queryParamFilters, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/transaction-item',
    params: params,
  })

  return response?.data
}

export const get = (queryParamFilters) => async (queryParam) =>
  await _get(queryParamFilters, queryParam)

export const show = async (trxId, trxItemId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `transaction/${trxId}/transaction-item/${trxItemId}`,
  })

  return response?.data
}

export const _store = async (trxId, data) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `transaction/${trxId}/transaction-item`,
    data,
  })

  return response?.data
}

export const store = (trxId) => async (data) => await _store(trxId, data)

export const update = async (trxId, trxItemId, data) => {
  const response = await apiClientV2({
    method: 'PATCH',
    baseURL,
    url: `transaction/${trxId}/transaction-item/${trxItemId}`,
    data,
  })

  return response?.data
}

export const _delete = async (trxId, trxItemId) => {
  const response = await apiClientV2({
    method: 'DELETE',
    baseURL,
    url: `transaction/${trxId}/transaction-item/${trxItemId}`
  })

  return response?.data
}

export const deleteSingle = (trxId) => async (trxItemId) => await _delete(trxId, trxItemId)

export const uploadFile = async (trxId, trxItemId, data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }
  const url = `transaction/${trxId}/transaction-item/${trxItemId}/attachment`
  const response = await apiClientV2.post(url, formData, {
    baseURL,
    headers: { 'Content-Type': 'multipart/form-data' }
  })

  return response?.data
}

export const updateFile = async (trxId, trxItemId, fileId, data) => {
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value)
  }
  const url = `transaction/${trxId}/transaction-item/${trxItemId}/attachment/${fileId}`
  const response = await apiClientV2.patch(url, formData, {
    baseURL,
    headers: { 'Content-Type': 'multipart/form-data' }
  })

  return response?.data
}

export const replaceByTemplate = async (transactionId, templateId) => {
  const response = await apiClientV2({
    method: 'PUT',
    baseURL,
    url: `/transaction/${transactionId}/transaction-item/replace-template`,
    data: {
      template_id: templateId,
    }
  })

  return response?.data
}